module.exports = __webpack_public_path__ + "static/img/yAxis.b5a09958.svg";